import axios from 'axios'

class API {

  constructor() {
    this.instance = axios.create()
  }

  async call(endpoint, body) {
    return this.instance.post('/api', body, { headers: { endpoint } })
  }
}


export default API